import React from "react";
import { ChevronLeftUniversal, ChevronRightUniversal } from "@duxton-web/icons";
import { Button } from "@duxton-web/ui";

const SidebarTriggerV2 = (props) => {
  const { collapsed, onClick } = props;

  const Icon = collapsed ? ChevronRightUniversal : ChevronLeftUniversal;
  return (
    <Button
      shape="circle"
      icon={<Icon style={{ fontSize: 20 }} />}
      onClick={onClick}
      style={{ display: "inline-grid"}}
    />
  );
};

export default SidebarTriggerV2;
